module.exports = __webpack_public_path__ + "img/11.19ba270.png";